import { render, staticRenderFns } from "./test.vue?vue&type=template&id=c9e504c6"
import script from "./test.ts?vue&type=script&lang=js&external"
export * from "./test.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports